import axios from "axios";

// 1 Nov 2026: on *.pages.dev (the preview site) call the API on the same origin. The Pages function proxies /api to
// Railway, so the preview loads real data. Before this, preview.muviarts-in.pages.dev called muviarts-in.pages.dev
// and CORS blocked every request, so the preview showed an empty page. muviarts.in is unchanged.
const SAME_ORIGIN = typeof window !== "undefined" && /\.pages\.dev$/.test(window.location.hostname);
export const BACKEND_URL = SAME_ORIGIN ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function apiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
